module.exports = __webpack_public_path__ + "img/Jump Casting45.7e288ced.jpg";